module.exports = __webpack_public_path__ + "static/assets/aea95f1faec6930fafcedd55b9598679.svg";